
(function () {
  'use strict';
  angular.module('vcdms.vcdocument')
    .component('documenteditor', {
      restrict: 'E',
      bindings: {
        document: '<?',
        documentid: '<?'
      },
      template: `
        <documentform document="vm.document" parentsave="vm.childsave(document)" oncancel="vm.oncancel()">
        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> document erfolgreich gespeichert!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen document wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> document konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Document', 'Rlog',
        function ($log, Document, Rlog) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.oncancel = oncancel;
          
/*          vm.$onInit = function () {
            if ((angular.isUndefined(vm.document) || !vm.document.hasOwnProperty('_id'))
              && angular.isDefined(vm.documentid)) {
              getDocument();
            }
          };*/


          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.documentid) && angular.isDefined(changes.documentid.currentValue) && changes.documentid.currentValue.length > 0) {
              vm.documentid = changes.documentid.currentValue;
              getDocument();
            }
          };


          function getDocument() {
            Document.$find(vm.documentid).$then(function (document) {
              vm.document = document;
            }, function (err) {
              $log.error('document not found, id: ', vm.documentid, err);
              Rlog.error('document', 'documenteditor', 'document not found', {_id: vm.documentid});
            });
          }
          
          function childsave(doc) {
            // vm.document = angular.copy(document);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in doc) {
              if (doc.hasOwnProperty(key)) {
                vm.document[key] = doc[key];
              }
            }
            vm.save();
          }
          
          function save() {
            if (vm.document.$hasPendingActions()) {
              vm.document.$cancel();
              vm.document.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of document failed: ', err);
                Rlog.error('vcutils.document', 'documenteditor', 'Saving of document failed: ', {documentid: vm.document._id});
              });
            }
            else {
              vm.document.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of document failed: ', err);
                Rlog.error('vcutils.document', 'documenteditor', 'Saving of document failed: ', {documentid: vm.document._id});
              });
            }
          }
          
          function oncancel() {
            vm.canceled = true;
          }
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());
